'use client';
import { checkCookieYesConsent } from '@bw/core';
import { getCookie, setCookie } from 'cookies-next';
import { OptionsType } from 'cookies-next/lib/types';
import { MouseEvent, ReactNode, useEffect, useRef, useState } from 'react';
import { useAppContext } from '../form-stepper/StepperProvider';
import styles from './AnnouncementBar.module.scss';

export function AnnouncementBarDynamicSizer(props: {
	hoursBeforeReappearing: number;
	children: ReactNode;
}) {
	const announcementRef = useRef<HTMLDivElement>(null);
	const { setAnnouncementBannerHeight } = useAppContext() ?? {};
	const [closed, setClosed] = useState<boolean>(false);
	const [cookieFetched, setCookieFetched] = useState<boolean>(false);

	useEffect(() => {
		if (announcementRef.current) {
			setAnnouncementBannerHeight(announcementRef.current.clientHeight);
		}
	}, [announcementRef]);

	useEffect(() => {
		// Check the cookie to determine if the announcement is closed
		const announcementClosedCookie = getCookie('announcementClosed');

		setClosed(announcementClosedCookie ? true : false);
		announcementClosedCookie ? setAnnouncementBannerHeight(0) : null;
		setCookieFetched(true);
	}, []);

	const closeAnnouncementBar = (hoursBeforeReappearing: number) => {
		// Set a cookie to remember the closed state and reappearing duration
		const expires = hoursBeforeReappearing
			? new Date(Date.now() + hoursBeforeReappearing * 60 * 60 * 1000)
			: undefined;

		// Set cookie only if consent given for functional cookies
		if (
			checkCookieYesConsent('consent') &&
			checkCookieYesConsent('functional')
		) {
			setCookie('announcementClosed', true, {
				expires: expires,
			} as OptionsType);
		}

		setClosed(true);
		setAnnouncementBannerHeight(0);
	};

	const processLink = (e: MouseEvent) => {
		if (e.target instanceof HTMLAnchorElement) {
			e.preventDefault();
			e.stopPropagation();
			window.open(e.target.href, '_blank');
		}
	};

	return closed ? null : (
		<div
			className={`${styles['announcementBar']} ${cookieFetched ? '' : styles['announcementBar--hidden']}`}
			ref={announcementRef}
		>
			<div className={styles['content']} onClick={processLink}>
				{props.children}
			</div>

			<button
				className={styles['close-btn']}
				onClick={() => closeAnnouncementBar(props.hoursBeforeReappearing)}
			>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="16"
					height="16"
					viewBox="0 0 16 16"
					fill="none"
				>
					<path
						d="M12 4L4 12M4 4L12 12"
						stroke="#003049"
						strokeWidth="1.33333"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg>
				<span>Close</span>
			</button>
		</div>
	);
}
